import { Card, Spin } from "antd";
import WizardHeader from "modules/components/WizardHeader";
import React from "react";
import ErrorWidget from "components/Widgets/ErrorWidget";
import { StepThankYou } from "../../common/steps";
import useInitAvenant from "views/pages/subscription/mono/avenant/useInitAvenant";
import { useSelector } from "react-redux";
import * as helpers from 'helpers/helpers';
import { StepDetails } from "./steps";

export default function AvenantAnnulation() {

    const { avenant, partnerCode, contract, category } = useSelector((state) => state.subscription);
    const { currentStep, page, basket, transactionResponse, initAvenantResponse } = useSelector((state) => state.basketSlice);

    const {state} = useInitAvenant()
    

    if(state.isInitAvenantLoading) {
        return <Card><Spin /> Chargement et configuration en cours ...</Card>
    }

    if(state.iniAvenantLoadingError) {
        return <ErrorWidget errorMessage={state.iniAvenantLoadingErrorMessage} />;
    }

    function renderChildren() {
        switch (currentStep) {
            case 0:
                return <StepDetails
                            avenantCode={avenant?.code}
                            endDate={initAvenantResponse}
                            subscriptionRequest={basket?.subscriptionRequest}
                            packSelected={basket?.packSelected}
                            />
            case 1:
                if(page === helpers.PAGES.THANK_YOU) {
                    return <StepThankYou transactionResponse={transactionResponse} />;
                }

                break;

            default:
                return <ErrorWidget errorMessage="Ooops ! la page n'existe pas" />;

        }
    }

    return (
        <React.Fragment>
            <WizardHeader
                title={`Categorie ${category?.code} : ${category?.title}`}
                avenantTilte="Avenant d'annulation"
                police={contract?.policeNumber}
                partnerCode={partnerCode}
                percent={100}
            />
            {renderChildren()}
        </React.Fragment>
    )
}